import * as type from '../actions/types';

const initialState = {
    myWorks: [],
    loading: false,
    error: null,
}

export default function myWorks(state = initialState, action) {
    switch (action.type) {
        case type.GET_MY_WORKS_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_MY_WORKS_SUCCESS:
            return {
                ...state,
                loading: false,
                myWorks: action.data
            }
        case type.GET_MY_WORKS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}